import React from "react";
import ReactDOM from "react-dom";

import HexModal from "../../../app/components/modals/HexModal";
import { showErrorMessage } from "../../commons/show-error-message";
import {
  findGiftCards,
  findModels,
} from "../../../infrastructure/repository/benefit-models-repository";

import GiftCardModal from "../../../app/components/modals/benefits/GiftCardModal";
import { logError, addContextLog } from "../../../infrastructure/log";
import { translate } from "../../../infrastructure/translate/localization";

function renderGiftCardModal({ giftCards, benefitSelected = {} }) {
  ReactDOM.render(
    <HexModal>
      <GiftCardModal giftCards={giftCards} benefit={benefitSelected} />
    </HexModal>,
    document.getElementById("modal-container")
  );
}

export async function displayGiftCardModal(benefitId) {
  let giftCards = [];

  try {
    renderGiftCardModal({ giftCards });
    const giftCardsDetail = await findGiftCards();
    giftCards = giftCardsDetail.data;
    const { data: models } = await findModels();
    const benefitSelected = models.find((benefit) => benefit.id === benefitId);

    renderGiftCardModal({ giftCards, benefitSelected });
    addContextLog("info", "renderGiftCardModal", "display-screen");
  } catch (e) {
    logError(e, `Error to displayGiftCardModal in benefit`);
    showErrorMessage(translate("common-messages.basic-error-message"));
  }
}
